export const checkoutTimes = [
	{ label: '5:00 PM', value: '17:00:00' },
	{ label: '6:00 PM', value: '18:00:00' },
	{ label: '7:00 PM', value: '19:00:00' },
	{ label: '8:00 PM', value: '20:00:00' },
	{ label: '9:00 PM', value: '21:00:00' },
	{ label: '10:00 PM', value: '22:00:00' },
	{ label: '11:00 PM', value: '23:00:00' },
];
